var map = {
	"./admin/admin.module": [
		"./src/app/main/admin/admin.module.ts",
		"admin-admin-module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./backoffice/backoffice.module": [
		"./src/app/main/backoffice/backoffice.module.ts",
		"backoffice-backoffice-module~main-main-module~order-order-module",
		"backoffice-backoffice-module~order-order-module",
		"common"
	],
	"./forgot/forgot.module": [
		"./src/app/auth/forgot/forgot.module.ts",
		"forgot-forgot-module"
	],
	"./login/login.module": [
		"./src/app/auth/login/login.module.ts",
		"login-login-module"
	],
	"./main/main.module": [
		"./src/app/main/main.module.ts",
		"backoffice-backoffice-module~main-main-module~order-order-module",
		"common"
	],
	"./order/order.module": [
		"./src/app/main/backoffice/order/order.module.ts",
		"backoffice-backoffice-module~main-main-module~order-order-module",
		"backoffice-backoffice-module~order-order-module",
		"common",
		"order-order-module"
	],
	"./roles/roles.module": [
		"./src/app/main/admin/user_mgmt/roles/roles.module.ts",
		"common",
		"roles-roles-module"
	],
	"./synchronisation/synchronisation.module": [
		"./src/app/main/admin/synchronisation/synchronisation.module.ts",
		"synchronisation-synchronisation-module"
	],
	"./user_mgmt/user_mgmt.module": [
		"./src/app/main/admin/user_mgmt/user_mgmt.module.ts",
		"user_mgmt-user_mgmt-module"
	],
	"./users/users.module": [
		"./src/app/main/admin/user_mgmt/users/users.module.ts",
		"common",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;